import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { createTabsComponent } from '@flipster/react/design-system/tabs';

import { marketPageBunja } from '../../state';
import { SearchTabType } from '../../types';

const Tabs = createTabsComponent<SearchTabType>();

const searchTabLabelId = {
  perpetual: 'Assets.r250401.Perpetual',
  tradfi: 'Market.r260205.TradFi',
  spot: 'Assets.r250401.Spot',
} as const satisfies Record<SearchTabType, string>;

export const MarketSearchTab = () => {
  const t = useTranslations();
  const { searchTabsAtom, searchTabAtom, setSearchCursorTab } = useBunja(marketPageBunja);
  const searchTabs = useAtomValue(searchTabsAtom);
  const tab = useAtomValue(searchTabAtom);

  return (
    <Tabs type='scrollable' value={tab} onClick={setSearchCursorTab} border>
      {searchTabs.map((searchTab) => (
        <Tabs.Tab key={searchTab} value={searchTab} label={t(searchTabLabelId[searchTab])} />
      ))}
    </Tabs>
  );
};
